import { useId } from "react";

import type { TipoObraTagSize } from "../tipo-obra-tag";
import { TIPO_OBRA_TAGS_POR_LINHA, TIPO_OBRA_TOOLTIP_PROPS } from "./tipo-obra-tags.constants";
import styles from "./tipo-obra-tags.module.scss";
import type { TipoObraTagsProps } from "./types-tipo-obra-tags";

/** ViewModel do `TipoObraTags`: tamanho da tag, linha única dos cards, lista para o leitor de tela e testids; sem JSX. */
export function useTipoObraTags({ tipos, size = "table", compacto = false }: TipoObraTagsProps) {
  const escopo = useId();
  const itens = tipos.map((item) => (typeof item === "string" ? { codigo: item } : item));
  const isCard = size === "card";
  const lista = compacto ? itens.map(({ codigo }) => codigo).join(", ") : undefined;
  const tagSize: TipoObraTagSize = isCard ? "md" : "sm";

  return {
    isEmpty: itens.length === 0,
    lista,
    role: compacto ? ("group" as const) : undefined,
    tagSize,
    className: [
      styles.tags,
      isCard ? styles.card : "",
      isCard && itens.length <= TIPO_OBRA_TAGS_POR_LINHA ? styles.cardLine : "",
    ]
      .filter(Boolean)
      .join(" "),
    tags: itens.map(({ codigo, tipo }) => ({
      codigo,
      tooltip: tipo ? `${codigo} · ${tipo}` : undefined,
      testId: `obra-tipo-${codigo}`,
    })),
    /** Uma tooltip por bloco, presa aos alvos `data-pr-tooltip` dele; sem nomes não há alvo e ela não monta. */
    escopo,
    hasTooltip: itens.some(({ tipo }) => Boolean(tipo)),
    tooltipTarget: `[data-tipo-obra-tags="${escopo}"] [data-pr-tooltip]`,
    tooltipProps: TIPO_OBRA_TOOLTIP_PROPS,
  };
}
